<template>
  <div class="main">
    <my_menu active_name="0-1" :open_active="['0']"></my_menu>

    <div class="content">
      <div>
        <Tabs @on-click="click_tabs" v-model="current_tab">
          <TabPane
            :name="String(i)"
            v-for="(item, i) in tabs_data"
            :key="i"
            :label="item.name"
          ></TabPane>
        </Tabs>
      </div>
      <div class="options">
        <Tabs @on-click="click_auth_type" :value="auth_type" size="small">
          <TabPane label="应用" name="1"></TabPane>
          <TabPane label="API" name="0"></TabPane>
        </Tabs>

        <Button
          style="font-size: 10px"
          size="small"
          @click="add_auth_show = true"
          icon="ios-add-circle-outline"
          type="primary"
          >添加权限</Button
        >
      </div>
      <div class="table_box">
        <Spin fix size="large" v-if="table_loading"></Spin>
        <Table
          size="small"
          :height="windowHeight - 135"
          border
          :columns="columns"
          :data="authority_list"
        >
          <template #name="{ row }">
            <div>
              <span class="name" @click="click_auth_name(row)">{{ row.name }}</span>
              <Icon type="ios-create-outline" style="margin-left: 3px" color="#666" />
            </div>
          </template>
        </Table>
      </div>
    </div>
  </div>

  <Modal
    width="420"
    v-model="update_auth_show"
    title="更新名称"
    @on-ok="update_auth_name_ok"
  >
    <div class="form_item">
      <div class="form_item_title">权限名称：</div>
      <Input
        style="width: 250px"
        type="text"
        v-model="current_item.name"
        placeholder="权限名称"
      >
      </Input>
    </div>
  </Modal>

  <Modal width="420" v-model="add_auth_show" title="添加权限" :footer-hide="true">
    <div>
      <Form ref="add_auth" :model="add_auth_data" :rules="add_auth_rules" inline>
        <FormItem prop="name">
          <div class="form_item">
            <div class="form_item_title">权限名称：</div>
            <Input
              style="width: 250px"
              type="text"
              v-model="add_auth_data.name"
              placeholder="权限名称"
            >
            </Input>
          </div>
        </FormItem>
        <!-- <FormItem prop="dx_sys_id">
                    <div class="form_item">
                        <div class="form_item_title">大象系统ID：</div>
                        <Input style="width: 250px" type="text" v-model="add_auth_data.dx_sys_id"
                            placeholder="大象系统模块ID">
                        </Input>
                    </div>
                </FormItem> -->
        <div class="add_sys_button">
          <Button type="primary" @click="add_auth_ok('add_auth')">确认添加</Button>
        </div>
      </Form>
    </div>
  </Modal>
</template>

<script>
import my_menu from "@/component/admin/menu/menu.vue";
import { http } from "@/utils/http.js";

export default {
  components: {
    my_menu,
  },
  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度

      //系统列表
      tabs_data: [],
      current_tab: 0,
      auth_type: 1,
      // 权限列表
      table_loading: false,
      authority_list: [],
      columns: [],

      add_auth_show: false,
      add_auth_data: {
        name: "",
        dx_sys_id: "",
      },
      add_auth_rules: {
        name: [
          { required: true, message: "请输入权限名称", trigger: "blur" },
          { type: "string", min: 2, message: "请输入权限名称", trigger: "blur" },
        ],
      },

      current_item: {},
      update_auth_show: false,
    };
  },

  mounted() {
    this.window_change();
    this.get_sys_list();
  },

  methods: {
    update_auth_name_ok() {
      var that = this;
      var obj = {
        name: that.current_item.name,
        auth_id: that.current_item.auth_id,
      };
      console.log(obj);
      http(
        "post",
        process.env.VUE_APP_HOST + "/authority_manage/update_auth_name",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_auth_sys_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          that.$Message.error({
            content: "请求超时",
            duration: 3,
          });
        });
    },

    click_auth_name(item) {
      console.log(item);

      this.current_item = JSON.parse(JSON.stringify(item));
      this.update_auth_show = true;
    },

    click_auth_type(e) {
      console.log(e);
      this.auth_type = e;
      this.get_auth_sys_list();
    },

    click_tabs(e) {
      this.current_tab = e;
      this.get_auth_sys_list();
    },

    //添加权限确认
    add_auth_ok(name) {
      var that = this;
      this.$refs[name].validate((valid) => {
        console.log(valid);
        if (valid) {
          var obj = {
            name: that.add_auth_data.name,
            auth_sys_id: that.tabs_data[Number(this.current_tab)]["auth_sys_id"],
            auth_type: that.auth_type,
          };
          console.log(obj);
          http("post", process.env.VUE_APP_HOST + "/authority_manage/add_auth", obj, true)
            .then((res) => {
              if (res.code == 0) {
                that.$Message.success({
                  content: res.msg,
                  duration: 3,
                });
                that.add_auth_show = false;
                that.get_auth_sys_list();
              } else {
                that.$Message.error({
                  content: res.msg,
                  duration: 3,
                });
              }
            })
            .catch((res) => {
              that.$Message.error({
                content: "请求超时",
                duration: 3,
              });
            });
        } else {
        }
      });
    },

    //点击添加
    click_add_sys(e) {
      console.log(e);
      this.add_sys_show = true;
    },

    //获取系统权限列表
    get_auth_sys_list() {
      var that = this;
      that.table_loading = true;
      var obj = {
        auth_type: this.auth_type,
        auth_sys_id: this.tabs_data[Number(this.current_tab)]["auth_sys_id"],
      };
      http("post", process.env.VUE_APP_HOST + "/authority_manage/auth_list", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.authority_list = res.data.authority_list;
            that.columns = res.data.columns;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.table_loading = false;
        })
        .catch((res) => {
          that.table_loading = false;
          console.log(res, "请求出错");
        });
    },

    //获取系统列表
    get_sys_list() {
      var that = this;
      var obj = {};
      http("post", process.env.VUE_APP_HOST + "/authority_manage/sys_list", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.tabs_data = res.data.sys_list;
            that.get_auth_sys_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    window_change() {
      var that = this;
      // <!--把window.onresize事件挂在到mounted函数上-->
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          window.fullWidth = document.documentElement.clientWidth;
          that.windowHeight = window.fullHeight; // 高
          that.windowWidth = window.fullWidth; // 宽
        })();
      };
    },
  },
};
</script>

<style scoped>
.name:hover {
  cursor: pointer;
  color: #0466dd;
  font-weight: 600;
}

/deep/ .ivu-tabs-bar {
  margin-bottom: 10px;
}

.circular {
  width: 25px;
  height: 25px;
}

.table_box {
  position: relative;
}

.add_sys_button {
  margin-top: 20px;
  text-align: right;
}

.form_item_title {
  flex-shrink: 0;
  width: 100px;
}

.form_item {
  display: flex;
  align-items: center;
}

.options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 10px;
  margin-bottom: 10px;
}

.content {
  padding: 10px;
  width: calc(100% - 220px);
  background-color: #fff;
  position: absolute;
  right: 10px;
  top: 10px;
  height: calc(100vh - 20px);
  border-radius: 5px;
}

.main {
  background: #ececec;
  min-height: 100vh;
}
</style>
